/* eslint-disable jsx-a11y/click-events-have-key-events -- TODO */
import type { ReactNode } from "react";

import { cn } from "../../../utils";
import type {
  TableColumnGroup,
  TableProps,
  TableRowType,
} from "../Table.types";

interface TableGroupProps<
  Row extends TableRowType,
  Group extends string = never,
>
  extends
    Pick<
      TableProps<Row, Group>,
      "activeGroupIds" | "onGroupClick" | "renderGroupEffect"
    >,
    Required<Pick<TableProps<Row, Group>, "getGroupId">> {
  row: Row;
  group: TableColumnGroup<Group>;
  rowIndex: number;
  children: ReactNode;
  className?: string;
  gridColumnRules: string[];
}

export const TableGroup = <
  Row extends TableRowType,
  Group extends string = never,
>({
  row,
  group,
  rowIndex,
  children,
  className,
  activeGroupIds,
  gridColumnRules,
  getGroupId,
  onGroupClick,
  renderGroupEffect,
}: TableGroupProps<Row, Group>) => {
  const onClick = group.group
    ? () =>
        group.group &&
        onGroupClick?.({
          row,
          group: group.group,
          groupId: getGroupId(row, group.group, rowIndex),
          rowIndex,
        })
    : undefined;

  return (
    <div
      role="button"
      tabIndex={-1}
      key={group.start}
      className={cn(
        "ui:grid",
        {
          "ui:relative ui:cursor-pointer": group.group,
        },
        className,
      )}
      style={{
        gridColumn: `${(group.start + 1).toString()} / ${(group.end + 2).toString()}`,
        gridTemplateColumns: gridColumnRules
          .slice(group.start, group.end + 1)
          .join(" "),
      }}
      onClick={onClick}
    >
      {group.group
        ? (renderGroupEffect?.({
            row,
            group: group.group,
            rowIndex,
            isActive:
              activeGroupIds?.includes(
                getGroupId(row, group.group, rowIndex),
              ) ?? false,
          }) ?? null)
        : null}

      {children}
    </div>
  );
};
